import React from 'react';
import { KatCheckbox, KatIcon } from '@amzn/katal-react';
import { WidgetProps } from '@rjsf/utils';
import { MANDATORY_FIELD_IDENTIFIER } from 'src/react-jsonschema-katal/katal/constants/ApplicationConstants';
import styled from 'styled-components';
import { IconViewWidget } from '../components/ViewWidget';
import { ErrorMessage } from 'src/components/Error';
import Spacer from 'src/components/Layout/Spacer';
import { DescriptionWidget } from '../components/ViewWidget/DescriptionWidget';

const CHECKBOX_ERROR_STATE = 'error';

interface ErrorProps {
  state: string;
  stateLabel: string;
}

const CheckboxWidgetArea = styled.div<{ isError?: boolean }>`
  kat-checkbox {
    --indicator-border-color: ${({ theme, isError }) =>
      isError ? theme.colors.Crimson : theme.colors.Eastern};
    --font-size: ${({ theme }) => theme.fontSize.m};
  }
`;

const CheckboxWidget: React.FC<WidgetProps> = ({
  value,
  onChange,
  disabled,
  label,
  required,
  uiSchema,
  rawErrors,
}) => {
  if (disabled) {
    return value ? (
      <IconViewWidget
        label={label}
        icon={<KatIcon name="check_box" size="small" />}
      />
    ) : (
      <IconViewWidget
        label={label}
        icon={<KatIcon name="check_box_outline_blank" size="small" />}
      />
    );
  }

  if (required) {
    label = `${label}${MANDATORY_FIELD_IDENTIFIER}`;
  }

  let additionalErrorProps: Partial<ErrorProps> = {};
  if (rawErrors && rawErrors.length > 0) {
    additionalErrorProps.state = CHECKBOX_ERROR_STATE;
    additionalErrorProps.stateLabel = rawErrors.map((error) => error).join(',');
  } else {
    additionalErrorProps = {};
  }

  const descriptionWidget = <DescriptionWidget size="xs" uiSchema={uiSchema} />;
  return (
    <CheckboxWidgetArea
      isError={additionalErrorProps?.state === CHECKBOX_ERROR_STATE}
    >
      <KatCheckbox
        label={label}
        checked={value}
        disabled={disabled}
        onChange={(e: KatCheckbox.ChangeEvent) => onChange(e.detail.checked)}
      />
      {additionalErrorProps?.state === CHECKBOX_ERROR_STATE && (
        <ErrorMessage message={additionalErrorProps.stateLabel!} />
      )}

      {descriptionWidget && (
        <>
          <Spacer height=".3rem" />
          {descriptionWidget}
        </>
      )}
    </CheckboxWidgetArea>
  );
};

export default CheckboxWidget;
